import { useQuery } from '@tanstack/react-query';
import Global from '../../../../../Services/Common/Global';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../../../util';
import {
  Wait_Schema,
  MapWaitDashboardR1ToViewModel,
  GetEmptyWaitDashboardViewModel,
  MapGetRisCustom00R2ResponseToRows,
} from './Wait_Schema';

/**
 * 위험성평가 대기(워크플로) 대시보드 — RisCustom.GetRisCustom00R1
 * SaveRisBasicResult, Data = [ { ProgressList, ActivityLogList, ProgressRateTxt } ]
 * URL 없음·실패·매핑 실패 시 빈 모델
 */
export const useWaitDashboard1 = (options = {}) => {
  const { custCd, rsCd, titleOverride = '', enabled = true } = options;

  const apiPath = Global.urls.RiskEvaluation?.getRisCustom00R1;

  return useQuery({
    queryKey: ['RiskEvaluation', 'waitDashboard1', custCd, rsCd, titleOverride],
    queryFn: async () => {
      if (!apiPath || !Number(rsCd) || Number(rsCd) <= 0) {
        return GetEmptyWaitDashboardViewModel(titleOverride);
      }
      const params = mapParamsBySchema(Wait_Schema.mapper.getRisCustom00R1, {
        rsCd,
        searchText: '',
      });
      try {
        const raw = await apiRequest('post', apiPath, params);
        const failed =
          raw && (raw.IsSuccess === false || raw.isSuccess === false);
        if (failed) {
          return GetEmptyWaitDashboardViewModel(titleOverride);
        }
        const mapped = MapWaitDashboardR1ToViewModel(raw, { titleOverride });
        if (mapped) return mapped;
      } catch {
      }
      return GetEmptyWaitDashboardViewModel(titleOverride);
    },
    enabled: enabled && !!custCd && Number(rsCd) > 0,
  });
};

/**
 * 활동 로그 전체 — RisCustomController.GetRisCustom00R2
 * SaveRisBasicResult (GetRisCustom00R1ActivityLogItem 목록), Data = 리스트
 */
export const useActivityLogFull = (options = {}) => {
  const { rsCd, searchText = '', open = false } = options;
  const path = Global.urls.RiskEvaluation?.getRisCustom00R2;

  const params = mapParamsBySchema(Wait_Schema.mapper.getRisCustom00R2, {
    rsCd,
    searchText,
  });

  return useQuery({
    queryKey: ['RiskEvaluation', 'getRisCustom00R2', params],
    queryFn: async () => {
      if (!path) {
        return [];
      }
      try {
        const raw = await apiRequest('post', path, params);
        const failed =
          raw && (raw.IsSuccess === false || raw.isSuccess === false);
        if (failed) {
          throw new Error(
            raw?.Message ?? raw?.message ?? '활동 로그 조회에 실패했습니다.'
          );
        }
        return MapGetRisCustom00R2ResponseToRows(raw);
      } catch (e) {
        const data = e?.response?.data;
        const fromBody =
          typeof data === 'string' && data.trim()
            ? data
            : data?.Message ?? data?.message;
        throw new Error(
          fromBody || e?.message || '활동 로그 조회에 실패했습니다.'
        );
      }
    },
    enabled: !!open && !!path && Number(rsCd) > 0,
    staleTime: 0,
  });
};
